import { Navbar } from "flowbite-react"
import useAuth from "../../hooks/useAuth"
import { Link, useNavigate } from "react-router-dom"
import useSignOut from "../../hooks/useSignOut"
import useRefreshToken from "../../hooks/useRefreshToken"
import { FC, PropsWithChildren, useEffect } from "react"
import useToasts from "../../hooks/useToasts"
import NavbarUserDropdown from "./NavbarUserDropdown"
import HT_TRAINING_logo_letters_horiz_big from "../../assets/images/HT_TRAINING_logo_letters_horiz_big.svg"

export type NavbarAdminProps = PropsWithChildren<{
  collapseSidebar: () => void
}>

const NavbarAdmin: FC<NavbarAdminProps> = ({ collapseSidebar, children }) => {
  const { auth } = useAuth()
  const signOut = useSignOut()
  const refresh = useRefreshToken()
  const navigate = useNavigate()

  const { toastList, setToastList } = useToasts()

  useEffect(() => {
    if (!auth) {
      refresh()
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const signout = async () => {
    const result = await signOut()
    if (result) {
      setToastList(
        toastList.concat({
          type: "success",
          link: { to: "/signin", text: "Sign in" },
          children: "Successfully signed out!",
        })
      )
    } else {
      setToastList(
        toastList.concat({
          type: "failure",
          children: "Error signing out!",
        })
      )
    }

    navigate("/")
  }

  return (
    <nav className="fixed top-0 z-40 w-full !bg-neutral-900 !dark:bg-neutral-900 rounded-t-none">
      <div className="px-3 py-3 lg:px-5 lg:pl-3 container mx-auto">
        <div className="flex items-center justify-between">
          <div className="flex items-center justify-start">
            <button
              onClick={collapseSidebar}
              aria-controls="logo-sidebar"
              type="button"
              className="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
            >
              <span className="sr-only">Open sidebar</span>
              <svg
                className="w-6 h-6"
                aria-hidden="true"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  clipRule="evenodd"
                  fillRule="evenodd"
                  d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
                ></path>
              </svg>
            </button>
            <Navbar.Brand as={Link} to="/">
              <img
                src={HT_TRAINING_logo_letters_horiz_big}
                className="mr-3 h-16 sm:h-16"
                alt="HackTricks Training Logo"
              />
              {/* <span className="self-center whitespace-nowrap text-xl font-semibold dark:text-white">
            HackTricks Training
          </span> */}
            </Navbar.Brand>
          </div>
          <div className="flex items-center">
            <div className="flex items-center ml-3">
              <NavbarUserDropdown auth={auth} signout={signout} />
            </div>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default NavbarAdmin
